import { takeLatest, put, call } from 'redux-saga/effects';

import { listPatrimonioAbastecimentoCadastro } from '../service';
import {
  TABLE_PATRIMONIO_ABASTECIMENTO_CADASTRO,
  TABLE_PATRIMONIO_ABASTECIMENTO_CADASTRO_PENDING,
  TABLE_PATRIMONIO_ABASTECIMENTO_CADASTRO_SUCCESS,
  TABLE_PATRIMONIO_ABASTECIMENTO_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaListPatrimonioAbastecimentoCadastro(action) {
  yield put({ type: TABLE_PATRIMONIO_ABASTECIMENTO_CADASTRO_PENDING })

  try {
    const table = yield call(listPatrimonioAbastecimentoCadastro, action.args)
    yield put({ type: TABLE_PATRIMONIO_ABASTECIMENTO_CADASTRO_SUCCESS, table: table })
  } catch (error) {
    yield put({ type: TABLE_PATRIMONIO_ABASTECIMENTO_CADASTRO_FAILURE })
  }
}

export default function* watchListPatrimonioAbastecimentoCadastro() {
  yield takeLatest(TABLE_PATRIMONIO_ABASTECIMENTO_CADASTRO, sagaListPatrimonioAbastecimentoCadastro)
}
